module.exports = __webpack_public_path__ + "img/vizio3-cover-1.f5fafc5e.jpg";